/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, Tab, Tabs, Typography } from '@mui/material';

const TabPanel = ({ children, value, index, ...other }) => (
  <Typography
    aria-labelledby={`simple-tab-${index}`}
    component="div"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    role="tabpanel"
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </Typography>
);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const getTabPanels = (tabPanels, tab) =>
  tabPanels.map((t, i) => (
    <TabPanel key={i} value={tab} index={i}>
      {t.element}
    </TabPanel>
  ));

const getTabs = (tabPanels) =>
  tabPanels.map((t, i) => (
    <Tab
      key={i}
      label={t.label}
      id={`simple-tab-${i}`}
      sx={{
        '&:not(:first-of-type)': { ml: -0.125 },
        bgcolor: (theme) => theme.palette.neutral[800],
        color: 'text.secondary',
        opacity: 1,
        '&.Mui-selected': {
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          borderBottomWidth: 0,
        },
        '& .MuiTab-wrapper': { opacity: 0.7 },
      }}
    />
  ));

const TabFormV2 = ({ tabPanels, currentTab, onChangeTab }) => {
  const [tab, setTab] = useState(currentTab);
  const handleChange = (event, newValue) => {
    onChangeTab(newValue);
    setTab(newValue);
  };

  useEffect(() => {
    if (Number.isInteger(currentTab) && currentTab !== tab) setTab(currentTab);
  }, [currentTab]);

  return (
    <Box
      sx={{
        boxShadow:
          '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
        borderRadius: 1,
        bgcolor: 'background.paper',
        border: (theme) => `0.5px solid ${theme.palette.neutral[800]}`,
      }}
    >
      <AppBar
        position="static"
        sx={{
          bgcolor: (theme) => theme.palette.neutral[800],
          boxShadow: 'none',
        }}
      >
        <Tabs
          value={tab}
          onChange={handleChange}
          TabIndicatorProps={{ sx: { display: 'none' } }}
        >
          {getTabs(tabPanels)}
        </Tabs>
      </AppBar>
      {getTabPanels(tabPanels, tab)}
    </Box>
  );
};

TabFormV2.propTypes = {
  tabPanels: PropTypes.array.isRequired,
  currentTab: PropTypes.number,
  onChangeTab: PropTypes.func,
};

TabFormV2.defaultProps = {
  currentTab: 0,
  onChangeTab: () => {},
};

export default TabFormV2;
